import { useMemoizedContentGetter } from 'utils/contentful'
import { FlatCarousel } from 'components/Carousels/FlatCarousel'

function TestimonialCarousel({ content }) {
  let memoizedContent = useMemoizedContentGetter(content, ['carousel'])

  const {
    carousel: { carouselItemsCollection },
  } = memoizedContent

  return <FlatCarousel carouselItems={carouselItemsCollection?.items} idPrefix="home" />
}
export { TestimonialCarousel }
export default TestimonialCarousel
